import React from "react";
import {Document} from "@react-pdf/renderer";

const PdfGenerator = (props) => {
	const MyDocument = () => (<Document title={props.title}>{props.template}</Document>);

	return (<MyDocument/>);
}

export default PdfGenerator;